import { AuthStep, TwoFactorMethod, UserIntent } from './reducer';

export enum UserAuthActionType {
  SET_USER_AUTH_STEP = `SET_USER_AUTH_STEP`,
  SET_USER_INTENT = `SET_USER_INTENT`,
  SET_2FA_METHODS = `SET_2FA_METHODS`,
  RESET_USER_AUTH = `RESET_USER_AUTH`,
}

export interface SetUserAuthStep {
  type: UserAuthActionType.SET_USER_AUTH_STEP;
  payload: {
    authStep: AuthStep;
  };
}

export interface SetUserAuthIntent {
  type: UserAuthActionType.SET_USER_INTENT;
  payload: {
    userIntent: UserIntent;
  };
}

export interface SetTwoFactorMethods {
  type: UserAuthActionType.SET_2FA_METHODS;
  payload: {
    twoFactorMethods: TwoFactorMethod[];
  };
}

export interface ResetUserAuth {
  type: UserAuthActionType.RESET_USER_AUTH;
}

export type UserAuthActions = SetUserAuthStep | SetUserAuthIntent | SetTwoFactorMethods | ResetUserAuth;
